var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaveIconForSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 35,
    rx: 5,
    fill: "#D23333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.2573C19.2667 15.2573 17.5875 15.5395 16.0167 16.07V19.5688C16.0167 20.0203 15.7675 20.4041 15.41 20.5847C14.3483 21.1377 13.3842 21.8488 12.5175 22.6727C12.3333 22.8758 12.0625 23 11.7917 23C11.4667 23 11.1958 22.8646 11.0008 22.6614L8.31417 19.8623C8.11303 19.6528 8.00002 19.3686 8 19.0722C8 18.7562 8.11917 18.474 8.31417 18.2709C11.6183 14.9977 16.0817 13 21 13C25.9183 13 30.3817 14.9977 33.6858 18.2709C33.8808 18.474 34 18.7562 34 19.0722C34 19.377 33.8808 19.6591 33.6858 19.8623L30.9992 22.6614C30.8042 22.8646 30.5333 23 30.2083 23C29.9312 22.9953 29.6668 22.8778 29.4717 22.6727C28.6158 21.8488 27.6517 21.1377 26.59 20.5847C26.4074 20.492 26.2535 20.3475 26.1462 20.1678C26.0389 19.9881 25.9824 19.7805 25.9833 19.5688V16.07C24.4125 15.5395 22.7333 15.2573 21 15.2573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveIconForSm);
export default __webpack_public_path__ + "static/media/leaveIconForSm.48b46ff674534f94ae2277ee93f92de9.svg";
export { ForwardRef as ReactComponent };